import { Grid } from '@mui/material';
// import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa6';
import seniorSquad from '../../../hooks/SeniorSquad.json';
import juniorSquad from '../../../hooks/JuniorSquad.json';
// import traineeSquad from '../../../hooks/traineeSquad.json';
const TeamMember = () => {
  const handlelinkedin = (value) => {
    window.open(value, '_blank', 'noopener,noreferrer');
    // eslint-disable-next-line no-debugger
  };

  return (
    <>
      <div className="team_area pt-85 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="section_title text_left mb-60 mt-3">
                <div className="section_sub_title uppercase mb-3">
                  {/* <h6>TEAM MEMBER</h6> */}
                </div>
                <div className="section_main_title">
                  <h2>Our Awesome Creative</h2>
                  <h2>Squad</h2>
                </div>
                <div className="em_bar">
                  <div className="em_bar_bg"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="section_button mt-50">
                <div className="button two">
                  <Link to="/contact">Join Our Team</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-center mt-60">
            {seniorSquad.map((list, index) => (
              <div
                className="col-lg-3 col-md-6 col-sm-12 col-xs-12"
                key={index}
              >
                <div className="team_style_three mb-30">
                  <div className="team_style_three_inner">
                    <div className="team_style_three-thumb">
                      <div className="team_style_three_thumb_inner">
                        <img src={list.image} alt="" />
                        <div className="overlay">
                          <p
                            style={{ fontSize: list.fontSize }}
                            className="px-2"
                          >
                            {list.description}{' '}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="team_style_three_content c-pointer">
                      <div className="team_style_three_title">
                        <p>
                          {list.empName}
                          <span className="ml-3">
                            <FaLinkedin
                              onClick={() => handlelinkedin(list.linkedIn)}
                              className="c-pointer"
                            />
                          </span>
                        </p>
                      </div>
                      <div className="team_style_three_sub_title">
                        <span>{list.role}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="container mt-70">
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            className="mt-70"
          >
            {juniorSquad.map((list) => (
              <Grid item xs={12} sm={12} md={3} lg={3} key={list.empId}>
                <div className="image-wrapper">
                  <img
                    src={list.image}
                    className="img-fluid"
                    alt={list.empName}
                  />
                  <div className="overlay1">
                    <div className="name">{list.empName}</div>
                    <div className="role">{list.role}</div>
                    <span>
                      <FaLinkedin
                        style={{ fontSize: list.fontSize }}
                        onClick={() => handlelinkedin(list.linkedIn)}
                        className="c-pointer"
                      />
                    </span>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
        {/* <div className="container mt-70">
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            className="mt-70"
          >
            {traineeSquad.map((list) => (
              <Grid item xs={12} sm={12} md={3} lg={3} key={list.empId}>
                <div className="image-wrapper">
                  <img
                    src={list.image}
                    className="img-fluid"
                    alt={list.empName}
                  />
                  <div className="overlay1">
                    <div className="name">{list.empName}</div>
                    <div className="role">{list.role}</div>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </div> */}
      </div>
    </>
  );
};

export default TeamMember;
